import { defineStore } from 'pinia';
import {getSizes} from '../api.js';

export const useSizeStore = defineStore('sizes', {
    state: () => ({
        sizes: [],
        loading: false,
        error: null
    }),
    actions: {
        async fetchSizes() {
            this.loading = true;
            this.error = null;
            try {
                const data = await getSizes();
                this.sizes = data.data;
            } catch (err) {
                this.error = err;
            } finally {
                this.loading = false;
            }
        }
    },
});
